import { render, staticRenderFns } from "./CjhdList.vue?vue&type=template&id=2dc3ae21&scoped=true"
import script from "./CjhdList.vue?vue&type=script&lang=js"
export * from "./CjhdList.vue?vue&type=script&lang=js"
import style0 from "./CjhdList.vue?vue&type=style&index=0&id=2dc3ae21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc3ae21",
  null
  
)

export default component.exports